import {AssemblySearchRequest} from "../ImpellerAssemblyService";
import React, {useRef, useState} from "react";

export function AssemblyCriteriaUploader(props: { onUpload: (criteria: AssemblySearchRequest) => void }) {

    const [inputKeyForComponentReset, setInputKeyForComponentReset] = useState(1);

    // Hiding original for styling
    const hiddenFileInput = useRef<HTMLInputElement>(null);

    const proxyClick = () => {
        if (hiddenFileInput.current == null) {
            return;
        }
        hiddenFileInput.current.click();
    }

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
        if (e.target.files === null) {
            console.log("no files selected on change.");
            return;
        }
        const fileReader = new FileReader();
        fileReader.readAsText(e.target.files[0], "UTF-8");
        // Reset on every attempt, not only on success — otherwise re-picking the same file after
        // a rejected load never fires onChange again. FileReader keeps its File reference, so the
        // input remount does not interrupt the read in progress.
        setInputKeyForComponentReset(prev => prev + 1);
        fileReader.onload = e => {
            if (e.target == null || e.target.result == null) {
                alert("Cannot load assembly criteria");
                return;
            }

            let json: string;
            if (e.target.result instanceof ArrayBuffer) {
                json = new TextDecoder().decode(e.target.result)
            } else {
                json = e.target.result;
            }

            try {
                const parsed: any = JSON.parse(json);
                if (parsed.hasOwnProperty("criteriaVersion")) {
                    if (parsed.criteriaVersion === 1) {
                        console.log("Parsed uploaded assembly criteria: ", parsed)

                        // Remove the criteriaVersion property to get clean AssemblySearchRequest
                        const {criteriaVersion, ...cleanCriteria} = parsed;

                        props.onUpload(cleanCriteria as AssemblySearchRequest);
                        return;
                    }
                    alert("Cannot load assembly criteria: unsupported criteria file version");
                    return;
                }
                alert("Cannot load assembly criteria: no version specified");
            } catch (error) {
                console.error("Failed to parse assembly criteria file:", error);
                alert("Cannot load assembly criteria: invalid JSON file");
            }
        };
    };

    return (
        <>
            <button className={"btn btn-sm btn-outline btn-outline-primary"} onClick={proxyClick}>
                <i className="fas fa-folder-open"></i>
            </button>
            <input ref={hiddenFileInput} style={{ display: "none" }} key={inputKeyForComponentReset} type="file" onChange={handleChange} accept=".json"/>
        </>
    );
}